import { Empty } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import allActions from '../../../actions';
import * as loadingKeys from '../../../actions/MaterialDetailsDomain/LoadingKeys';
import '../MaterialDetails.css';
import styles from '../styles.module.scss';
import PlantCard from './PlantComponents/PlantCard';
import PlantColumnsCard from './PlantComponents/PlantColumnsCard';

function PlantElements({ hasViewerAccess }) {
  const { plant } = useParams();
  const dispatch = useDispatch();
  const plantRelationships = useSelector((state) => state.materialDetailsState.plantRelationships);
  const loading = useSelector((state) => state.materialDetailsState.loading);

  useEffect(() => {
    dispatch(allActions.MaterialDetailsActions.setLoading(loadingKeys.relatedPlants));
    dispatch(allActions.MaterialDetailsActions.fetchPlantRelationships(plant));
  }, [plant]);

  const plants = plantRelationships?.[plant]?.map((relatedPlant) => (
    <PlantCard
      plantID={relatedPlant.Plant_ID}
      loading={loading?.[loadingKeys.relatedPlants] ?? false}
      hasViewerAccess={hasViewerAccess}
    />
  ));

  return (
    plants?.length > 0
      ? (
        <div className={styles.relatedPlantViewContainer}>
          <div className={styles.relatedPlantsView} style={{ gridTemplateColumns: plants.length > 2 ? `1fr ${plants.map(() => '1fr').join(' ')}` : `300px ${plants.map(() => '300px').join(' ')}` }}>
            <PlantColumnsCard />
            {plants}
          </div>
        </div>
      )
      : <Empty />
  );
}

export default PlantElements;
PlantElements.defaultProps = {
  hasViewerAccess: false,
};
PlantElements.propTypes = {
  hasViewerAccess: PropTypes.bool,
};
